module.exports = __webpack_public_path__ + "static/media/details-2.50c23e62.jpeg";